import { render } from "./ReverseProxy.vue?vue&type=template&id=6c0f7b47&scoped=true"
import script from "./ReverseProxy.vue?vue&type=script&lang=js"
export * from "./ReverseProxy.vue?vue&type=script&lang=js"

import "./ReverseProxy.vue?vue&type=style&index=0&id=6c0f7b47&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0f7b47"]])

export default __exports__